<!-- <div [class]="'w-auto p-3'"> -->
  <div [class]="classefecto">

    <h3>{{ titulo }}</h3>
    <div class="row">
      <div class="col-md-6">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html">Home</a></li>
            <li class="breadcrumb-item">{{ modulo }}</li>
            <li class="breadcrumb-item active">{{ tituloCard }}</li>
          </ol>
        </nav>
      </div>
      <ng-container *ngTemplateOutlet="innTemplateButton">
        <ng-template #innTemplateButton>
        </ng-template>
      </ng-container>
    </div>


    <div class="col-sm-12">
      <!-- <div class="card border-success"> -->
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ tituloCard }}</h5>

          <ng-container *ngTemplateOutlet="innTemplate">
            <ng-template #innTemplate>
            </ng-template>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
<!-- </div> -->